<template>
  <div class="centent">
    <div :class="{ streeKeyfourShow: streeKeyfourShow }" class="titlefont">
      <div class="titleAnimation">
        <div class="title">内行人士教你分辨「机构好坏」</div>
        <div class="desc">
          <span>只罗列事实，不做凡尔赛</span>
        </div>
      </div>
    </div>
    <div class="cont" :class="{ streeKeyfourShow: streeKeyfourShow }">
      <div class="contInfo itemA">
        <div class="item">
          <div class="leftBox">
            <div class="topBox">
              <div class="titA">课程对比</div>
            </div>
            <div class="desBox">
              <ul>
                <li>项目数量</li>
                <li>真项目 + 真实战</li>
                <li>多行业、多渠道覆盖</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="item itemW">
          <div class="leftBox">
            <div class="topBox">
              <div class="titB"><img src="./../images/CZlogo.png" /></div>
            </div>
            <div class="desBox">
              <div class="desText">
                <div class="tit">8大企业级项目就业方向广 、选择多</div>
                <p>
                  社群运营方案实训、社群快速裂变实训、企业全媒体矩阵运营方案、公众号数据诊断实训、短视频制作实训、短视频运营实训、短视频电商直播实训、活动策划运营实训
                </p>
              </div>
              <div class="desText">
                <div class="tit">12+真实企业对接</div>
                <p>
                  真实经营项目、真实收益可见、真实案例产出、增加1-2年职场经验
                </p>
              </div>
              <div class="desText">
                <div class="tit">
                  18个热门行业、13个新媒体渠道、120套企业运营方案
                </div>
                <p style="font-weight: bold;">【行业】</p>
                <p>
                  社会类、宠物类、健康类、餐饮类、健身类、事实类、美妆类、科技类、文化类、教育类、旅游类、服饰类、娱乐类、个性类、金融类、母婴类、汽车类、房产类
                </p>
                <p style="font-weight: bold;">【渠道】</p>
                <p>
                  视频号、B站、今日头条、公众号、快手、抖音、微博、TIKTOK、知乎、西瓜视频、小程序、百家号、小红书
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="leftBox">
            <div class="topBox">
              <div class="titC">部分机构</div>
            </div>
            <div class="desBox">
              <ul class="elseBox">
                <li>仅几个撰写方案类小项目</li>
                <li>纸上谈兵无落地执行、 项目过时不符合企业需求、 模拟假项目</li>
                <li>2-3个普通行业</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    streeKeyfourShow: {
      type: Boolean,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style src="./../style.scss" rel="stylesheet/scss" lang="scss" scoped></style>
<style lang="scss" scoped>
</style>
